var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-business-content"},[_c('h3',{staticClass:"main-business-title"},[_vm._v("\n           "+_vm._s(_vm.details.title)+"\n       ")]),_vm._v(" "),_c('div',{staticClass:"addtime"},[_vm._v(_vm._s(_vm.details.addtime))]),_vm._v(" "),_c('div',{staticClass:"business-info",domProps:{"innerHTML":_vm._s(_vm.details.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38bd8bc9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/businessDetail.vue
// module id = null
// module chunks = 